(() => {
  'use strict';
  if (window.MayhemFitmentService) return;
  const requests = new Map();
  const request = async (path, filters) => {
    const url = new URL('https://api.autosyncstudio.com' + path);
    url.searchParams.set('key', 'mayhem');
    Object.entries(filters).forEach(([key, value]) => url.searchParams.set(key, value));
    if (!requests.has(url.href)) requests.set(url.href, (async () => {
      for (let attempt = 0; attempt < 3; attempt++) {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 12000);
        try {
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) throw new Error('AutoSync request failed');
          const data = await response.json();
          if (data.Error || data.MoreItems) throw new Error('Incomplete AutoSync response');
          return data;
        } catch (error) { if (attempt === 2) throw error; }
        finally { clearTimeout(timer); }
        await new Promise(resolve => setTimeout(resolve, 500 * (attempt + 1)));
      }
    })().catch(error => { requests.delete(url.href); throw error; }));
    return requests.get(url.href);
  };
  const vehicle = async id => {
    if (!/^\d{1,12}$/.test(String(id))) throw new Error('Invalid vehicle');
    const data = await request('/vehicles', { 'f-id': id, 'i-fitments': 'true', 'i-optionalFitments': 'true', 'i-plusSizes': 'true', 'i-img001': 'true', 'i-img014': 'true', 'i-img032': 'true' });
    return data.Vehicles?.find(row => String(row.Id) === String(id));
  };
  const wheels = async skus => {
    const rows = new Map();
    const unique = [...new Set(skus.filter(Boolean).map(String))];
    while (unique.length) {
      const batch = []; let length = 0;
      while (unique.length && batch.length < 60 && length + unique[0].length < 850) { const sku = unique.shift(); batch.push(sku); length += sku.length + 1; }
      if (!batch.length) throw new Error('Invalid SKU');
      const data = await request('/wheels', { 'f-pns': batch.join(','), 'p-size': 500, 'i-specs': 'true', 'i-img0100': 'true', 'i-img0200': 'true', 'i-img0300': 'true' });
      (data.Wheels || []).forEach(wheel => rows.set(String(wheel.Pn).toUpperCase(), wheel));
    }
    return rows;
  };
      const num = value => value === null || value === undefined || value === '' ? NaN : Number(value);
      const evaluateFitment = (vehicle, wheel, selection = null) =>
        window.MayhemFitmentPolicy?.evaluate(vehicle, wheel, selection) ||
        { state: 'unknown', reasons: [window.MayhemFitmentPolicyCopy?.unavailable || 'Fitment data is temporarily unavailable. Please try again.'] };

  window.MayhemFitmentService = { vehicle, wheels, evaluate: evaluateFitment };
})();


